module.exports = __webpack_public_path__ + "img/absolute-radio-90s.12018bfd.png";